<template>
    <div>
        <b-modal centered hide-footer hide-header :no-close-on-backdrop="true" header-class="bg-light-grey-1" footer-class="bg-light-grey-1" v-model="modalVisible" :size="modalSize">
            <div v-if="showDefaultAttributes" class="border-bottom-line-1">
                <div class="py-2 px-3">
                    <div class="d-flex justify-content-between align-items-center">
                        <div>
                            <p class="mb-0 fw-500 fs-20" v-html="title"></p>
                            <p v-if="subTitle" class="mb-0 fw-400 fs-14 text-muted" v-html="subTitle"></p>
                        </div>
                        <p class="close cursor-pointer fs-18 text-dark-grey-1 mb-0 material-icons" @click="closeModal">close</p>
                    </div>
                </div>
            </div>
            <div class="px-3">
                <slot></slot>
            </div>
        </b-modal>
    </div>
</template>

<script>

export default {
    name: 'ModalWithSlot',
    emits: ['close:modal'],
    props: {
        modalSize: {
            type: String,
            default: 'lg'
        },
        showModal: {
            type: Boolean,
            default: false 
        },

        showDefaultAttributes: {
            type: Boolean,
            default: true 
        },

        title: {
            type: String,
            default: '' 
        },

        subTitle: {
            type: String,
            default: '' 
        }
    },
    data() {
        return { 
            modalVisible: false,
        }
    },
    mounted() {
        this.modalVisible = this.showModal
    },
    watch: {
        showModal(newValue){
            this.modalVisible = newValue
        },
    },
    methods: {
        // openModal() {
        //     this.modalVisible = true
        // },
        closeModal() {
            this.modalVisible = false
            this.$emit('close:modal')
        },
},
           
}
</script>

<style scoped>
    ::v-deep(.modal-body) {
        padding: 0 !important;
    }
    ::v-deep(.modal-content) {
        border-radius: 1rem !important;
        border: none !important;
    }
</style>
